import { inject, Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '../store/store.service';

@Pipe({
  name: 'currencyAmount',
  standalone: true,
})
export class CurrencyAmountPipe implements PipeTransform {
  storeService = inject(StoreService);

  transform(value: number): number {
    return (
      this.storeService
        .store$()
        ?.panelSettings.base?.PriceSettings.Currencies.find(
          (f) => f.Type === value
        )?.Amount ?? 1
    );
  }
}
